import Link from 'next/link'

import ArrowForwardIos from '@mui/icons-material/NavigateNext'
import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material'

import { StyledAnchor } from '@/components/BreadcrumbsCustom/BreadcrumbsCustom.style'
import { formatLimitTextCharacters } from '@/helpers/formatLimitTextCharacters'
import { getCategoryBranch } from '@/helpers/getCategoryBranch'
import { useHeaderContext } from '@/hooks/useHeaderContext'
import { useTranslations } from '@/hooks/useTranslations'
import { colors } from '@/themes/commerce/colors'
import { commerceTheme as theme } from '@/themes/commerce/theme'

import type * as React from 'react'

interface BreadcrumbsCustomProps extends React.PropsWithChildren {
  categoryId?: string
  /** Provide true for categories in order to hide the Home link */
  categories?: boolean
  title?: string
}

export const BreadcrumbsCustom: React.FC<BreadcrumbsCustomProps> = ({
  categoryId = '',
  categories = false,
  title = '',
  children,
}) => {
  const { translate } = useTranslations()
  const { catalog } = useHeaderContext()
  const categoryBranch = categoryId.length > 0 && catalog.length > 0 ? getCategoryBranch(categoryId, catalog) : []
  const selectedCategory = categoryBranch.length

  if ((categories && selectedCategory === 0) || (categoryId.length === 0 && title.length === 0)) {
    return null
  }

  return (
    <MuiBreadcrumbs
      aria-label="breadcrumb"
      itemsAfterCollapse={2}
      itemsBeforeCollapse={2}
      maxItems={5}
      separator={
        <ArrowForwardIos sx={{ strokeWidth: 1, stroke: `${theme.palette.border.default}` }} fontSize="small" />
      }
      sx={{ color: colors.text.default, '.MuiBreadcrumbs-separator': { margin: 0 } }}
    >
      <StyledAnchor component={Link} href="/" key="home">
        {translate('breadcrumbs.home')}
      </StyledAnchor>
      {children || categories
        ? categoryBranch.map((pathItem, idx) =>
            selectedCategory !== idx + 1 ? (
              <StyledAnchor component={Link} href={pathItem?.url ? pathItem?.url : ''} key={`${idx}_${pathItem.id}`}>
                {pathItem?.name}
              </StyledAnchor>
            ) : (
              <Typography variant="body2" key={idx}>
                {pathItem?.name ? formatLimitTextCharacters(pathItem?.name, 30) : ''}
              </Typography>
            )
          )
        : categoryBranch.map((pathItem, idx) => (
            <StyledAnchor component={Link} href={pathItem?.url ? pathItem?.url : ''} key={`${idx}_${pathItem.id}`}>
              {pathItem?.name}
            </StyledAnchor>
          ))}
      {title.length > 0 && <Typography variant="body2">{formatLimitTextCharacters(title, 30)}</Typography>}
    </MuiBreadcrumbs>
  )
}
